/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* Krister Edit */

/* Header animation scroll */
document.addEventListener('scroll', function() {
    var header = document.querySelector('.shopify-section--header');
    
    if (window.scrollY > 180) {
        header.classList.add('Open');
    } else {
        header.classList.remove('Open');
    }
});

/*============================================================================
  Product description accordion - Changes accordions with H6 tag
==============================================================================*/
var faqAccordion = {
  init: function() {
    var flg = 0;
    var $faqHeading = $('.faqAccordion > dt > button');
    var $faqContent = $('.faqAccordion > dd');

    // Set all dd elements to be hidden by default and aria-hidden true
    $faqContent.attr('aria-hidden', true).hide();
    $faqHeading.attr('aria-expanded', false).find('.symbol').addClass('plus');

    // Open the first tab by default
    var $firstHeading = $faqHeading.first();
    $firstHeading.attr('aria-expanded', true).parent().next().attr('aria-hidden', false).show();
    $firstHeading.find('.symbol').removeClass('plus').addClass('minus');

    $faqHeading.on('click', function() {
      if (flg) return false;
      flg = 1;

      var $this = $(this);
      var $thisContent = $this.parent().next();

      // Check if the clicked tab is already open
      var isOpen = $this.attr('aria-expanded') === 'true';
      if (isOpen) {
        // If the tab is already open, do nothing
        flg = 0;
        return false;
      }

      // Close all other tabs
      $faqHeading.attr('aria-expanded', false);
      $faqContent.attr('aria-hidden', true).slideUp();
      $faqHeading.find('.symbol').removeClass('minus').addClass('plus');

      // If the clicked tab was open, do nothing (just close it)
      if (!isOpen) {
        // Open the clicked tab
        $this.attr('aria-expanded', true);
        $thisContent.slideDown(function() {
          flg = 0;

          // Smooth scroll to the top of the opened dd with an offset
          $('html, body').animate({
            scrollTop: $this.offset().top - 170 // Adjust the offset as needed
          }, 150); // Smooth scroll with 400ms duration
        }).attr('aria-hidden', false);

        // Toggle symbol
        $this.find('.symbol').removeClass('plus').addClass('minus');
      } else {
        // If we are closing the clicked tab, reset the flag
        flg = 0;
      }

      return false;
    });

    $faqHeading.on('keydown', function(event) {
      var keyCode = event.keyCode || event.which;
      if (keyCode === 13) {
        $(this).trigger('click');
      }
    });
  }
}

$(function() {
  faqAccordion.init();
});


/* Focus on search input when search link is clicked */
$(function() {
  function focus() {
    $('#ennakoiva-haku').focus();
  }

  $(document.body).load($(focus));
  $('#focusButton').click(focus);
});

$(document).ready(function() {
    $('#focusButton').on('click', function() {
        $('#ennakoivaHaku').focus();
    });
});

/* Start Globo Popuo on pageload 
window.addEventListener('load', function() {
    document.getElementById('globo-popup-form').click();
});*/

/* Smooth scroll kategoria description lue lisää */
document.addEventListener('DOMContentLoaded', function() {
    // Add click event listener to the specific anchor link with id #kategoria-tiedot
    const anchor = document.querySelector('a[href="#kategoria-tiedot"]');
    
    if (anchor) {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();

            // Get the target element
            const targetElement = document.getElementById('kategoria-tiedot');

            if (targetElement) {
                // Calculate the offset position
                const offsetPosition = targetElement.offsetTop - 120;

                // Smooth scroll to the offset position
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    }
});

/* Kategoria description Open up lue lisää kun asiakas painaa linkkiä */
$(document).ready(function(){
    $('.read-more').on('click', function() {
        var content = $('.collection-description-part-2');
        
        if (content.hasClass('open')) {
            content.removeClass('open');
            $(this).text('Lue lisää');

            // Scroll to the #kategoria-tiedot element with offset when "Read Less" is pressed
            $('html, body').animate({
                scrollTop: $('#kategoria-tiedot').offset().top - 120
            }, 500); // 500ms for smooth scroll
        } else {
            content.addClass('open');
            $(this).text('Sulje');
        }
    });
});

/* Offset when scrolling to reviews on product page */
document.querySelectorAll('a[href="#shopify-section-template--22829339574611__1722579898b5d84470"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();

        var target = document.getElementById('shopify-section-template--22829339574611__1722579898b5d84470');

        if (target) {
            var offset = 90; // Adjust this value to your desired offset
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    });
});

/* Hyvinvoinnin kulmakivet - Siirry sivun yläosaan, kun tulokset näytetään */
document.getElementById("quiz-kit-question-next-button").addEventListener("click", function() {
    window.scrollTo({
        top: 0,
        behavior: "smooth"  // This adds a smooth scrolling effect
    });
});
const spans = document.querySelectorAll('div.dmgWTv span');
spans.forEach(span => {
    if (span.textContent.trim() === 'Tilapäisesti loppunut') {
        span.classList.add('out-of-stock');
    }
});

/* Avaa kielivalikko jos suomen ulkopuolelta */
const button = document.querySelector('form.pristine > div > button.button.primary');
button.setAttribute('is', 'toggle-button');
button.setAttribute('aria-controls', 'product-template--16591778808016__product-content-db8fdf98-c1c6-4789-a2bf-512848060a7f-trust-1-drawer');
button.setAttribute('aria-expanded', 'false');


